import React, { useState } from "react";
import classnames from "classnames";
// reactstrap components
import {
  Button,
  Card,
  // CardHeader,
  CardBody,
  CardFooter,
  // CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Col,
} from "reactstrap";


import Footer from "../../components/Footer/Footer.js";

import NotificationAlert from "react-notification-alert";

import { LOGIN_USER, BARER_TOKEN,LOGIN_OUT } from "../../constants.js";
import axios from 'axios';
import ReactBSAlert from "react-bootstrap-sweetalert";
import { useLocation } from 'react-router-dom';
var to = "";
const Login = () => {
  let userna = localStorage.getItem("username");
  let password = localStorage.getItem("password");
  const [state, setState] = React.useState({});
  const [isChecked, setIsChecked] = useState(true);
  const [user, setUser] = useState({
    username: userna || "",
    password: password || "",
    isChecked: false,
  });
  const notificationAlertRef = React.useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const [alert, setAlert] = React.useState(null);
  const [isLoading, setIsLoading] = useState(false);

  let location = useLocation();
  const fullURL = window.location.href;
  const logoimg = fullURL.split(":")[1].split("//")[1]

  React.useEffect(() => {
       document.body.classList.toggle("login-page");
    return function cleanup() {
      document.body.classList.toggle("login-page");
    };
  });

  const subForm = async (e) => {
    e.preventDefault();
    if (user?.username !== "" && user?.password !== "") {
      loginApi();
    } else {
      let options = {};
      options = {
        place: "tr",
        message: "Username and Password are required",
        type: "warning",
        icon: "tim-icons icon-simple-remove",
        autoDismiss: 3,
      };
      notificationAlertRef.current.notificationAlert(options);

    }
  };

  const loginApi = async () => {
    setIsLoading(true)
    let payload = {
      method: "POST",
      body: JSON.stringify({
        username: user.username,
        password: user.password,
       firebaseclienttoken:"",
        barertoken:""
      }),

      // Adding headers to the request
      headers: {
        "Content-type": "application/json;",
      },
    };

    await fetch(LOGIN_USER, payload)
      .then((res) => res.json())
      .then((e) => {
        setIsLoading(false)
        if (e.status == 200) {
          loginUser(e)
       //   requestPermission()
        
        }  
        if(e.loginstatus ==1){
         // alreadyLogediin(e);
        
        } else {
          
          let options = {};
          options = {
            place: "tr",
            message: e.message,
            type: "warning",
            autoDismiss: 3,
          };
          notificationAlertRef.current.notificationAlert(options);
          //
              
         }
      })
      .catch((err) => {
        setIsLoading(false)
        let options = {};
        options = {
          place: "tr",
          message: err.toString(),
          type: "warning",

          autoDismiss: 3,
        };
        notificationAlertRef.current.notificationAlert(options);

        return {}; //(or [], or an empty return, or any return at all)
      });
  };

  // async function requestPermission(){
    
  //   const permission = await Notification.requestPermission();
  //   if(permission === 'granted'){
  //   const token  = await getToken(messaging,{vapidKey:"BKzdz7sPMf-BDRClfE3ccxcTj4HDgntY9S6gP64GDlMgUafoO7IoTFukvYF796e4tczm89x1NNNM7dEWnCRTFC8"})
  //     console.log("--firebase token ",token);
  //     localStorage.setItem("firebase",token)
  //   }else if(permission === 'denied'){
  //     console.log("Firebase Error ",permission);
  //   }
  // }
  const alreadyLogediin = (e) => {
    setAlert(
      <ReactBSAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => loginConfirm(e)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="success"
        cancelBtnBsStyle="danger"
        confirmBtnText="Yes, Login"
        cancelBtnText="Cancel"
        showCancel
        btnSize=""
      >
          You are Already Logged in another machine.
      </ReactBSAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };
  const loginConfirm = (e)=>{
    
      
     
      axios
        .post(LOGIN_OUT, {
          token: e.token,
          sender_id:e.sender_id,
          agenttype:e.agenttype,
          role:e.role,
          user_id:e.user_id,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("token"),
            token: localStorage.getItem("token"),
          },
        })
        .then((res) => {
         loginUser(e)
        })
        .catch((err) => {
          console.log(err);
          let options = {};
          options = {
            place: "tr",
            message: "You Can't logout",
            type: "warning",
            autoDismiss: 3,
          };
          notificationAlertRef.current.notificationAlert(options);
        });
    
  }

  const loginUser=(e)=>{
    
        
    localStorage.setItem("user", JSON.stringify(e));
    localStorage.setItem("menus", JSON.stringify(e.menus));
    localStorage.setItem("token", JSON.stringify(e.token));

    localStorage.username = user?.username;
    localStorage.password = user?.password;

    let options = {};
    options = {
      place: "tr",
      message: "You have successfully Login",
      type: "success",

      autoDismiss: 3,
    };

    notificationAlertRef.current.notificationAlert(options);
   if(e?.role=="Agent"){
    setTimeout(() => {
      const parts = window.location.pathname.split("/");
      window.location.href ="/netxcellservice/admin/agent/liveChat";
    //  window.location.href =`/${parts[1]}/admin/agent/liveChat`;
    }, 1000);
  }
  else{
    const parts = window.location.pathname.split("/");
   // window.location.href = `/${parts[1]}/admin`;
    window.location.href = "/netxcellservice/admin";
    // setTimeout(() => {
    //   window.location.href = "/admin";
    // }, 1000);
  }
   
  }
  
  return (
    <>{alert}
      <div className="content" style={{"margin":"3% auto"}}>
        <Container className="mt-5">
          <NotificationAlert ref={notificationAlertRef} />

          <Col className="ml-auto mr-auto " lg="4" md="6">
            <Form className="form" onSubmit={subForm}>
              <Card className="card-login card-white mb-0">
                <CardBody>
                  
                {/* <img
                    alt="https://converge-now.com/images/logo-new.png"
                    //src={require(`../../assets/img/${logoimg}.png`)}
                    src={require(`../../assets/img/${logoimg}.png`)}
                   
                    style={{
                      margin: "0px auto",
                      display: "block",
                      // borderBottom : "solid 1px #ddd",
                      // paddingBottom: "20px",
                      borderRadius: "0px",
                      width:"70px",
                    }}
                  /> */}
                  {/* <img
                    alt="https://converge-now.com/images/logo-new.png"
                   // src={"https://converge-now.com/images/logo-new.png"}
                   src={require(`../../assets/img/logo.png`)}
                    style={{
                      margin: "5px auto",
                      display: "block",
                      width: "75%",
                    }}
                  /> */}
                     {
                    logoimg===("converge-now.com"||"convergenow.ai")?
                    <img
                    alt="https://converge-now.com/images/logo-new.png"
                   // src={"https://converge-now.com/images/logo-new.png"}
                  // src={require(`../../assets/img/logo.png`)}
                  // src="https://converge-now.com/images/logo-new.png"
                 // src="https://convergenow.ai/images/finallogo4-2.png"
                    src={require(`../../assets/img/netxcell.png`)}
                    style={{
                      margin: "25px auto",
                      display: "block",
                      width: "95%",
                    }} /> :
                    logoimg===("convergenow.ai")?
                    <img
                    alt="https://converge-now.com/images/logo-new.png"
                   // src={"https://converge-now.com/images/logo-new.png"}
                  // src={require(`../../assets/img/logo.png`)}
                  // src="https://converge-now.com/images/logo-new.png"
                  src={require(`../../assets/img/netxcell.png`)}
                    style={{
                      margin: "25px auto",
                      display: "block",
                      width: "95%",
                    }} />:
                    <img
                    alt="https://converge-now.com/images/logo-new.png"
                   // src={"https://converge-now.com/images/logo-new.png"}
                  // src="https://converge-now.com/images/logo-new.png"
                   src={require(`../../assets/img/logo.png`)}
                    style={{
                      margin: "5px auto",
                      display: "block",
                      width: "75%",
                    }} />
                  }
                  <InputGroup
                    className={classnames({
                      "input-group-focus": state.usernameFocus,
                    })}
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="tim-icons icon-single-02" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Username"
                      type="text"
                      onFocus={(e) =>
                        setState({ ...state, usernameFocus: true })
                      }
                      onBlur={(e) =>
                        setState({ ...state, usernameFocus: false })
                      }
                      value={user.username}
                      onChange={(e) =>
                        setUser({ ...user, username: e.target.value })
                      }
                    />
                  </InputGroup>
                  <InputGroup
                    className={classnames({
                      "input-group-focus": state.passFocus,
                    })}
                  >
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="tim-icons icon-lock-circle" />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Password"
                      type={showPassword ? "text" : "password"}
                      onFocus={(e) => setState({ ...state, passFocus: true })}
                      onBlur={(e) => setState({ ...state, passFocus: false })}
                      value={user.password}
                      onChange={(e) =>
                        setUser({ ...user, password: e.target.value })
                      }
                    />
                    <i
                      onClick={() => setShowPassword(!showPassword)}
                      className={
                        showPassword
                          ? "fa fa-eye showPassword"
                          : "fa fa-eye-slash showPassword"
                      }
                      aria-hidden="true"
                    ></i>
                  </InputGroup>
                  <FormGroup check className="text-left">
                    <Label check>
                      <Input
                        type="checkbox"
                        checked={isChecked}
                        name="lsRememberMe"
                        onChange={(e) => setIsChecked(e.target.checked)}
                      />
                      <span className="form-check-sign" />
                      Remember me.
                    </Label>
                  </FormGroup>
                </CardBody>
                <CardFooter>
                  <p className="pull-right bold">
                    Next
                    <Button disabled={isLoading}
                      className="mb-3 ml-3  btn-icon btn btn-round"
                      color="primary"
                      size="md"
                    >
                      <i className="tim-icons icon-double-right" />
                    </Button>
                  </p>
                </CardFooter>
              </Card>
            </Form>
          </Col>
        </Container>
      </div>
      {/* <div className="footer-login">
      <Footer />
      </div> */}
    </>
  );
};

export default Login;
